import { Badge, Box } from '@mui/material';
import { CSSProperties } from 'react';

interface Props {
  image: string | null | undefined;
  isUnread?: boolean;
  width?: CSSProperties['width'];
}

function RequestImage({ image, isUnread, width = '75px' }: Props) {
  return (
    <Box
      position="relative"
      maxWidth={width}
      height={{
        xs: width,
        md: 'auto',
      }}
      minHeight={width}>
      <Badge
        invisible={!isUnread}
        color="primary"
        variant="dot"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          width: '100%',
          height: '100%',
          aspectRatio: {
            xs: '1/1',
            md: 'auto',
          },
          '.MuiBadge-badge': {
            minWidth: 10,
            height: 10,
            borderRadius: '50%',
          },
        }}>
        <img
          src={image || '/no-pictures.png'}
          alt="Tattoo inspiration"
          style={{
            objectFit: 'cover',
            width: '100%',
          }}
        />
      </Badge>
    </Box>
  );
}

export default RequestImage;
